import React, { useEffect, useState, useCallback } from 'react';
import {
  Alert,
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Dropdown,
  Menu,
  Modal,
  Row,
  Space,
  Spin,
  Table,
  Typography,
  message,
  // message,
} from 'antd';
import {
  EllipsisOutlined,
  ReloadOutlined,
  SwapRightOutlined,
} from '@ant-design/icons';
import { Chart } from 'react-google-charts';
import { ErrorOrderLine, ButtonIcon, Label, Loading } from 'components/common';
import {
  fetchDashboardEmployeeShipment,
  fetchDashboardLocation,
  fetchDashboardInventoryChange,
  fetchDashboardPendingAudit,
  fetchDashboardPendingPORecv,
  getDashboardInventoryInfo,
  getDashboardOrderInfo,
  getDashboardOrderPending,
  getDashboardShipmentsPending,
  getDashboardShipmentsShipped,
  getDashboardShipmentsSpecial,
} from 'services/dashboard';
import moment from 'moment';
import { convertToUtcTime } from 'utils';
import { getUSPreviousBusinessDay } from 'utils/BusinessRange';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { Link, useHistory } from 'react-router-dom';
// import { fetchProfileSettings } from 'services/user';
import ErrorDetail from './ErrorDetail';
import { /*COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,*/ LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

const { Text, Title } = Typography;
const { RangePicker } = DatePicker;

const useViewport = () => {
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return { width };
};

const employeeShipmentColumns = [
  {
    title: 'User',
    dataIndex: 'employee',
  },
  {
    title: 'Total Non-Batch Print',
    dataIndex: 'totalNonBatchPrint',
  },
  {
    title: 'Single Item',
    dataIndex: 'singleItem',
  },
  {
    title: 'Multiple Item',
    dataIndex: 'multiItem',
  },
  {
    title: 'Batch Print',
    dataIndex: 'batchPrint',
  },
];

const shippedColumns = [
  {
    title: 'Carrier',
    dataIndex: 'name',
    sorter: (a: any, b: any) => a.name.localeCompare(b.name, 'en'),
    key: '1',
  },
  {
    title: 'Qty',
    dataIndex: 'value',
    align: 'right' as const,
    sorter: (a: any, b: any) => a.value - b.value,
    key: '2',
  },
];
const statusColumns = [
  {
    title: 'Status',
    dataIndex: 'name',
    sorter: (a: any, b: any) => a.name.localeCompare(b.name, 'en'),
    key: '3',
  },
  {
    title: 'Qty',
    dataIndex: 'value',
    align: 'right' as const,
    sorter: (a: any, b: any) => a.value - b.value,

    key: '4',
  },
];
const QueuedColumns = [
  {
    title: 'Service',
    dataIndex: 'name',
    sorter: (a: any, b: any) => a.name.localeCompare(b.name, 'en'),
    key: '5',
  },
  {
    title: 'Queued Qty',
    dataIndex: 'queued',
    align: 'right' as const,
    sorter: (a: any, b: any) => a.queued - b.queued,
    key: '6',
  },
];
const nonQueuedColumns = [
  {
    title: 'Service',
    dataIndex: 'name',
    sorter: (a: any, b: any) => a.name.localeCompare(b.name, 'en'),
    key: '7',
  },
  {
    title: 'Non-Queued Qty',
    dataIndex: 'unqueued',
    align: 'right' as const,
    sorter: (a: any, b: any) => a.unqueued - b.unqueued,
    key: '8',
  },
];

const [startTempDate, endTempDate] = getUSPreviousBusinessDay(
  moment().endOf('day').format()
);

type InventoryInfoResponse = {
  audit: number;
  audit_hours: number;
  audit_time: string;
  poreceive: number;
  poreceive_hours: number;
  poreceive_time: string;
  return_WarehouseNum:number;
  return_audit: number;
  return_audit_time: string;
}

type DashboardProps = {
  checkServiceMapInfo?: boolean;
  isDefaultWarehouse: boolean;
  showOrderInfo: boolean;
  showShipmentInfo: boolean;
  warehouse: WarehouseRow;
}

export default function Dashboard(props: DashboardProps): JSX.Element {
  const {warehouse, showOrderInfo, isDefaultWarehouse} = props;
  const defaultWarehouseNum = Number(
    warehouse.warehouseNum
  );

  const userPermissions = useSelector(
    (state: RootState) => state.admin.userPermissions,
    shallowEqual
  );
  const userProfileSettings = useSelector(
    (state: RootState) => state.admin.userProfileSettings,
    shallowEqual
  );
  // eslint-disable-next-line
  const { width } = useViewport();
  const [rangeDate, setRangeDate] = useState<any>([
    moment(startTempDate).add(-1, 'days'),
    endTempDate,
  ]);
  const [rangeDate1, setRangeDate1] = useState<any>([
    moment(startTempDate).add(1, 'day').startOf('day'),
    moment().endOf('day'),
  ]);
  const [rangeDate2, setRangeDate2] = useState<any>([
    moment(startTempDate).add(1, 'day').startOf('day'),
    moment().endOf('day'),
  ]);
  const [rangeDate3, setRangeDate3] = useState<any>([
    moment(startTempDate).add(1, 'day').startOf('day'),
    moment().endOf('day'),
  ]);
  const [rangeDate4, setRangeDate4] = useState<any>([
    moment(startTempDate).add(1, 'day').startOf('day'),
    moment().endOf('day'),
  ]);
  const [rangeDate5, setRangeDate5] = useState<any>([
    moment(endTempDate).add(-1, 'year').startOf('day'),
    endTempDate,
  ]);
  const [rangeDate6, setRangeDate6] = useState<any>([
    moment(endTempDate).add(-1, 'year').startOf('day'),
    endTempDate,
  ]);
  const [rangeDate7, setRangeDate7] = useState<any>([
    endTempDate.startOf('day'),
    endTempDate.endOf('day'),
  ]);
  const [rangeDate9, setRangeDate9] = useState<any>([
    endTempDate.startOf('day'),
    endTempDate.endOf('day'),
  ]);

  const [detailVisible, setDetailVisible] = useState(false);
  const [employeeShipmentData, setEmployeeShipmentData] = useState<StringKAnyVPair[]>([]);
  const [inited, setInited] = useState(false);
  const [inventoryChange, setInventoryChange] = useState<StringKAnyVPair>({});
  const [inventoryInfo, setInventoryInfo] = useState<InventoryInfoResponse>();
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loading7, setLoading7] = useState(false);
  const [loading8, setLoading8] = useState(false);
  const [loading9, setLoading9] = useState(false);
  const [location, setLocation] = useState<StringKAnyVPair>({});
  const [mapServiceFailedNum, setMapServiceFailedNum] = useState(0);
  const [orderInfoTotal, setOrderInfoTotal] = useState<number>(0);
  const [orderPending, setOrderPending] = useState<any>();
  const [orderStatusInfo, setOrderStatusInfo] = useState<any>();
  const [pendingAudit, setPendingAudit] = useState<StringKAnyVPair>({});
  const [pendingPo, setPendingPo] = useState<StringKAnyVPair>({});
  const [rangeDateChanged, setRangeDateChanged] = useState<any[]>([]);
  const [refreshAll, setRefreshAll] = useState(false);
  const [reqQueuedQty, setReqQueuedQty] = useState(0);
  const [reqQueuedunQty, setReqQueuedunQty] = useState(0);
  const [shipmentPending, setShipmentPending] = useState<any>();
  const [shipmentShipped, setShipmentShipped] = useState<any>();
  const [shipmentSpecial, setShipmentSpecial] = useState<any>();
  const [showPendding, setShowPendding] = useState(false);
  const [showShipped, setShowShipped] = useState(false);
  const [spQueuedQty, setSpQueuedQty] = useState(0);
  const [spQueuedunQty, setSpQueuedunQty] = useState(0);

  const history = useHistory();

  React.useEffect(() => {
    if (userProfileSettings) {
      const temp = userProfileSettings.filter(
        (e) => e.settingCode === 'DashboardPendingRange'
      );
      if (temp.length > 0) {
        setRangeDate([
          moment(startTempDate).add(-Number(temp[0].settingValue), 'days'),
          endTempDate,
        ]);
      }
      setRefreshAll(true);
    }
  }, [userProfileSettings]);

  //first part
  const getOrderPending = useCallback(async (rd = rangeDate) => {
    try {
      setLoading(true);
      const res = await getDashboardOrderPending(defaultWarehouseNum, {
        start: convertToUtcTime(rd[0].startOf('day').format()),
        end: convertToUtcTime(rd[1].endOf('day').format()),
      });
      setLoading(false);
      if (res.isSuccess) {
        setOrderPending(res.data);
      }
    } catch (error) {
      setLoading(false);
    }
  }, [defaultWarehouseNum, rangeDate]);

  const getUriQueryDateRange = (start: moment.Moment, end: moment.Moment) => {
    return `${convertToUtcTime(start.startOf('day').format())}@${convertToUtcTime(end.endOf('day').format())}`;
  };

  //part two
  const getShipmentSpecial = useCallback(async (rd = rangeDate1) => {
    try {
      setLoading1(true);
      const res = await getDashboardShipmentsSpecial(defaultWarehouseNum, {
        start: convertToUtcTime(rd[0].startOf('day').format()),
        end: convertToUtcTime(rd[1].endOf('day').format()),
      });
      setLoading1(false);
      if (res.isSuccess) {
        setShipmentSpecial(res.data);
      }
    } catch (error) {
      setLoading1(false);
    }
  }, [defaultWarehouseNum, rangeDate1]);

  const getInventoryInfo = async () => {
    try {
      const { data, isSuccess, message: msg } = await getDashboardInventoryInfo(defaultWarehouseNum);
      if (data && isSuccess) {
        setInventoryInfo(data);
      } else {
        message.error(msg || 'Fetch inventory info failed!');
      }
    } catch (error) {
      console.log('error = ', error);
    }
  };

  const getShipmentPending = useCallback(async () => {
    try {
      setLoading2(true);
      const res = await getDashboardShipmentsPending(defaultWarehouseNum, {
        start: convertToUtcTime(rangeDate2[0].startOf('day').format()),
        end: convertToUtcTime(rangeDate2[1].endOf('day').format()),
      });
      setLoading2(false);
      if (res.isSuccess) {
        setShipmentPending(res.data);
        if (
          res.data.pending &&
          res.data.pending.requestservice &&
          res.data.pending.requestservice.length > 0
        ) {
          let tempReqTotalQueued = 0;
          let tempReqTotalunQueued = 0;
          res.data.pending.requestservice.map((item: any) => {
            tempReqTotalQueued += item.queued;
            tempReqTotalunQueued += item.unqueued;
            return true;
          });
          setReqQueuedQty(tempReqTotalQueued);
          setReqQueuedunQty(tempReqTotalunQueued);
        }
        if (
          res.data.pending &&
          res.data.pending.shippingservice &&
          res.data.pending.shippingservice.length > 0
        ) {
          let tempSpTotalQueued = 0;
          let tempSpTotalunQueued = 0;
          res.data.pending.shippingservice.map((item: any) => {
            tempSpTotalQueued += item.queued;
            tempSpTotalunQueued += item.unqueued;
            return true;
          });
          setSpQueuedQty(tempSpTotalQueued);
          setSpQueuedunQty(tempSpTotalunQueued);
        }
      }
    } catch (error) {
      setLoading2(false);
    }
  }, [defaultWarehouseNum, rangeDate2]);

  const getShipmentShipped = useCallback(async () => {
    try {
      setLoading3(true);
      const res = await getDashboardShipmentsShipped(defaultWarehouseNum, {
        start: convertToUtcTime(rangeDate3[0].startOf('day').format()),
        end: convertToUtcTime(rangeDate3[1].endOf('day').format()),
      });
      setLoading3(false);
      if (res.isSuccess) {
        setShipmentShipped(res.data);
      }
    } catch (error) {
      setLoading3(false);
    }
  }, [defaultWarehouseNum, rangeDate3]);

  const getOrderStatusInfo = useCallback(async () => {
    try {
      setLoading4(true);
      const res = await getDashboardOrderInfo(defaultWarehouseNum, {
        start: convertToUtcTime(rangeDate4[0].startOf('day').format()),
        end: convertToUtcTime(rangeDate4[1].endOf('day').format()),
      });
      setLoading4(false);

      if (res.isSuccess) {
        if (res.data.advanceProcess && res.data.advanceProcess.length > 0) {
          let tempTotal = 0;
          res.data.advanceProcess.map((item: any) => {
            tempTotal += item.value;
            return true;
          });
          setOrderInfoTotal(tempTotal);
          
        }

        if (Array.isArray(res.data.mapped)) {
          const failed = res.data.mapped.find((e: any) => e.name === 'Failed');

          if (failed && typeof failed.value === 'number') {
            setMapServiceFailedNum(failed.value);
          }
        }

        setOrderStatusInfo(res.data);
      }
    } catch (error) {
      setLoading4(false);
    }
  }, [defaultWarehouseNum, rangeDate4]);

  const getOrderStatusInfo2 = useCallback(async () => {
    try {
      setLoading4(true);
      const res = await getDashboardOrderInfo(defaultWarehouseNum, {
        start: convertToUtcTime(rangeDate4[0].startOf('day').format()),
        end: convertToUtcTime(rangeDate4[1].endOf('day').format()),
      });
      setLoading4(false);

      if (res.isSuccess) {
        if (Array.isArray(res.data.mapped)) {
          const failed = res.data.mapped.find((e: any) => e.name === 'Failed');

          if (failed && typeof failed.value === 'number') {
            setMapServiceFailedNum(failed.value);
          }
        }
      }
    } catch (error) {
      setLoading4(false);
    }
  }, [defaultWarehouseNum, rangeDate4]);

  const getEmployeeShipment = async (rd: any[] = rangeDate9) => {
    if (!warehouse.warehouseNum) return;

    const t1 = rd[0].startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    const t2 = rd[1].endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    setLoading9(true);
    //console.log('r', rd, t1, t2, warehouse.warehouseNum);
    try {
      const { data } = await fetchDashboardEmployeeShipment(warehouse.warehouseNum, {start: t1, end: t2});

      if (data && Array.isArray(data)) {
        //console.log('i', data);
        setEmployeeShipmentData(data);
      }
    } catch(e) {
      /*message.error({
        content: `Fetched audit info error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });*/
    } finally {
      setLoading9(false);
    }
  };

  const getLocation = async () => {
    if (!warehouse.warehouseNum) return;

    //const t1 = rd[0].startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    const t1 = endTempDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    //const t2 = rd[1].endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    const t2 = endTempDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    setLoading8(true);
    //console.log('r', rd, t1, t2, warehouse.warehouseNum);
    try {
      const { data: { location }} = await fetchDashboardLocation(warehouse.warehouseNum, {start: t1, end: t2});

      if (location && typeof location === 'object') {
        //console.log('i', location);
        setLocation(location);
      }
    } catch(e) {
      /*message.error({
        content: `Fetched audit info error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });*/
    } finally {
      setLoading8(false);
    }
  };

  const getInventoryChange = async (rd: any[] = rangeDate7) => {
    if (!warehouse.warehouseNum) return;

    const t1 = rd[0].startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    const t2 = rd[1].endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    setLoading7(true);
    //console.log('r', rd, t1, t2, warehouse.warehouseNum);
    try {
      const { data: { inventory }} = await fetchDashboardInventoryChange(warehouse.warehouseNum, {start: t1, end: t2});

      if (inventory && typeof inventory === 'object') {
        //console.log('i', audit);
        setInventoryChange(inventory);
      }
    } catch(e) {
      /*message.error({
        content: `Fetched audit info error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });*/
    } finally {
      setLoading7(false);
    }
  };

  const getPendingAudit = async (rd: any[] = rangeDate5) => {
    if (!warehouse.warehouseNum) return;

    const t1 = convertToUtcTime(rd[0].startOf('day').format('YYYY-MM-DDTHH:mm:ss'));
    const t2 = convertToUtcTime(rd[1].endOf('day').format('YYYY-MM-DDTHH:mm:ss'));
    setLoading5(true);
    //console.log('r', rd, t1, t2, warehouse.warehouseNum);
    try {
      const { data: { audit }} = await fetchDashboardPendingAudit(warehouse.warehouseNum, {start: t1, end: t2});

      if (audit && typeof audit === 'object') {
        //console.log('a', audit);
        setPendingAudit(audit);
      }
    } catch(e) {
      /*message.error({
        content: `Fetched audit info error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });*/
    } finally {
      setLoading5(false);
    }
  };

  const getPendingPORecv = async (rd: any[] = rangeDate6) => {
    if (!warehouse.warehouseNum) return;

    const t1 = rd[0].startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    const t2 = rd[1].endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    setLoading6(true);
    //console.log('r', rd, t1, t2, warehouse.warehouseNum);
    try {
      const { data: { po }} = await fetchDashboardPendingPORecv(warehouse.warehouseNum, {start: t1, end: t2});

      if (po && typeof po === 'object') {
        //console.log('p', po);
        setPendingPo(po);
      }
    } catch(e) {
      /*message.error({
        content: `Fetched audit info error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });*/
    } finally {
      setLoading6(false);
    }
  };

  const hasManagerReportPermission = () => {
    let ret = false;

    if (Array.isArray(userPermissions)) {
      const pm = userPermissions.find(e => e.permissionNum === 40023);

      //console.log('pm', pm);
      if (pm) ret = pm.permissionLevel > 0;
      //ret = pm && pm.permissionLevel > 0;
    }

    return ret;
  };

  const onCheckOutMapStatus = () => {
    const ed = getUriQueryDateRange(rangeDate1[0], rangeDate1[1]);

    //console.log('ed -->', ed);
    history.push(`/sales/view-orders?mapStatus=2&handleSearch=1&enterDate=${ed}`);
  };

  const renderCardTitle = (opt: StringKAnyVPair) => {
    const { dateRange } = opt;
    const onChange = (dt: any) => { if (opt.setDate && opt.fetchData) { opt.setDate(dt); opt.fetchData(dt); } };
    const refresh = () => opt.fetchData && opt.fetchData();

    return (<>
      <Title className="inline-block" level={5}>{opt.title}</Title>
      {dateRange && (<div className="inline-block">
        <Row align="middle">
          <span className="ant-picker ant-picker-range ant-picker-small fw-400 b-transparent bg-no">{dateRange[0].format('MM/DD/YYYY')}<SwapRightOutlined />{dateRange[1].format('MM/DD/YYYY')}</span>
          <Dropdown
            overlay={(
              <Menu>
                <Menu.Item key="refresh-btn" icon={<ReloadOutlined />} onClick={refresh}>
                  Refresh
                </Menu.Item>
                <Menu.Item key="date-picker">
                  {renderDatePicker(dateRange, onChange)}
                </Menu.Item>
              </Menu>
            )}
            //trigger={['click']}
          >
            <EllipsisOutlined className="cursor-pointer" />
          </Dropdown>
        </Row>
      </div>)}
    </>);
  };

  const renderDatePicker = (defaultValue: any, onChange: any) => {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <RangePicker
          size="small"
          style={{ width: 230 }}
          allowClear={false}
          value={defaultValue}
          format="MM/DD/YYYY"
          // onOpenChange={()=>{
          //     document.addEventListener('click', (e) => {
          //       e.stopPropagation();
          //     }, { once: true });
          // }}
          ranges={{
            Today: [moment().startOf('day'), moment().endOf('day')],
            Yesterday: [
              moment().add(-1, 'day').startOf('day'),
              moment().add(-1, 'day').endOf('day'),
            ],
            '2 days ago': [
              moment().add(-2, 'day').startOf('day'),
              moment().endOf('day'),
            ],
            '3 days ago': [
              moment().add(-3, 'day').startOf('day'),
              moment().endOf('day'),
            ],
            'This Week': [moment().startOf('week'), moment().endOf('week')],
            'Last Week': [
              moment().add(-1, 'week').startOf('week'),
              moment().add(-1, 'week').endOf('week'),
            ],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
          }}
          //onChange={(dates) => onChange(dates)}
          onChange={(dates: any) => { Array.isArray(dates) && setRangeDateChanged(dates); }}
          onOpenChange={open => { if (!open && rangeDateChanged.length > 1) { onChange(rangeDateChanged); setRangeDateChanged([]); }}}
        />
      </div>
    );
  };

  /* eslint-disable */
  useEffect(() => {
    if (refreshAll) {
      getOrderPending();
      getShipmentSpecial();
      getInventoryInfo();

      if (showPendding) {
        getShipmentPending();
      }
      if (showShipped) {
        getShipmentShipped();
      }
      if (showOrderInfo) {
        getOrderStatusInfo();
      }
      setRefreshAll(false);
    }
  }, [refreshAll]);

  useEffect(() => {
    if (showPendding && !shipmentPending) {
      getShipmentPending();
    }
  }, [showPendding]);

  useEffect(() => {
    if (showShipped && !shipmentShipped) {
      getShipmentShipped();
    }
  }, [showShipped]);

  useEffect(() => {
    if (showOrderInfo && !orderStatusInfo) {
      getOrderStatusInfo();
    }
  }, [showOrderInfo]);

  useEffect(() => {
    if (!inited) {
      if (!props.showOrderInfo && props.checkServiceMapInfo) {
        getOrderStatusInfo2();
      }

      getEmployeeShipment();
      getLocation();
      getInventoryChange();
      getPendingAudit();
      getPendingPORecv();
      getShipmentSpecial();
      setInited(true);
    }
  }, [inited, props]);

  /* eslint-enable */
  return (
    <>
      <Card className="dashboard-card bg-transparent card-body1 no-box-shadow mb-36" title={`Warehouse: ${warehouse.warehouseCode}`}>
        <Row gutter={[0, 5]} style={{ marginBottom: 10 }}>
          <Col span={24}>
            <ErrorOrderLine
              warehouseNum={Number(warehouse.warehouseNum)}
            />
          </Col>
          {!!inventoryInfo && inventoryInfo.audit > 0 && (
            <Col span={24}>
              <Alert
                message={`There are ${inventoryInfo.audit} Audit Batch records that has not been closed for more than ${inventoryInfo.audit_hours} hour(s).`}
                type="warning"
                action={
                  <Button
                    size="small"
                    onClick={() =>
                      history.push(`/inventory/audit-batch?endTime=${inventoryInfo.audit_time}&warehouse=${warehouse.warehouseNum}`)
                    }
                    icon={<ButtonIcon className="bi bi-file-earmark-text" />}
                  >
                    Detail
                  </Button>
                }
              />
            </Col>
          )}
          {!!inventoryInfo && !!inventoryInfo.return_WarehouseNum && inventoryInfo.return_audit > 0 && (
            <Col span={24}>
              <Alert
                message={`There are ${inventoryInfo.return_audit} Return Audit Batch records that has not been closed for more than 8 hour(s).`}
                type="warning"
                action={
                  <Button
                    size="small"
                    onClick={() =>
                      history.push(`/inventory/audit-batch?endTime=${inventoryInfo.return_audit_time}&warehouse=${inventoryInfo.return_WarehouseNum}`)
                    }
                    icon={<ButtonIcon className="bi bi-file-earmark-text" />}
                  >
                    Detail
                  </Button>
                }
              />
            </Col>
          )}
          {!!inventoryInfo && inventoryInfo.poreceive > 0 && (
            <Col span={24}>
              <Alert
                message={`There are ${inventoryInfo.poreceive} PO Receive records that has not been closed for more than ${inventoryInfo.poreceive_hours} hour(s).`}
                type="warning"
                action={
                  <Button
                    size="small"
                    onClick={() =>{
                      if(isDefaultWarehouse){
                        history.push(`/po/poReceiveBatch?startTime=${inventoryInfo.poreceive_time}&warehouse=${warehouse.warehouseCode}`)
                      }else {
                        Modal.confirm({
                          title: `Confirm switch to warehouse: ${warehouse.warehouseCode} ?`,
                          content: ``,
                          okText: 'Yes',
                          okType: 'default',
                          cancelText: 'No',
                          autoFocusButton: 'cancel',
                          onCancel() { },
                          onOk() {
                            localStorage.setItem(LS_DEFAULT_WAREHOUSE_KEY, `${warehouse.warehouseNum}`);
                            history.push(`/po/poReceiveBatch?startTime=${inventoryInfo.poreceive_time}&warehouse=${warehouse.warehouseCode}`)
                          },
                        });
                      }
                    }}
                    icon={<ButtonIcon className="bi bi-file-earmark-text" />}
                  >
                    Detail
                  </Button>
                }
              />
            </Col>
          )}
          {mapServiceFailedNum > 0 && (
            <Col span={24}>
              <Alert
                message={`${mapServiceFailedNum} orders was created without proper shipping service mapping in the past 24 hours.`}
                type="warning"
                action={
                  <Button
                    size="small"
                    icon={<ButtonIcon className="bi bi-file-earmark-text" />}
                    onClick={onCheckOutMapStatus}
                  >
                    Detail
                  </Button>
                }
              />
            </Col>
          )}

          {shipmentSpecial && !!shipmentSpecial.shopAroundFailed && shipmentSpecial.shopAroundFailed.count !== 0 && (
            <Col span={24}>
              <Alert
                message={`There are ${shipmentSpecial.shopAroundFailed.count} shipments that "shopping around" failed. You may try reprocess them.`}
                type="error"
                action={
                  <Button
                    size="small"
                    onClick={() =>
                      history.push(`/sales/shipments?shopAroundStatus=2&status=0|250|8|9|10&warehouseNum=${warehouse.warehouseNum}&s=${shipmentSpecial.shopAroundFailed.begin}&e=${shipmentSpecial.shopAroundFailed.end}`)
                    }
                    icon={<ButtonIcon className="bi bi-file-earmark-text" />}
                  >
                    Detail
                  </Button>
                }
              />
            </Col>
          )}

          {shipmentSpecial && shipmentSpecial.transferFailed !== 0 && (
            <Col span={24}>
              <Alert
                // message={`There are ${shipmentSpecial.transferFailed} third party warehouse shipments that has not been synchronized for more than 12 hours after they were created.`}
                message={`There are ${shipmentSpecial.transferFailed} shipments failed sync to 3PL.`}
                type="error"
                action={
                  <Button
                    size="small"
                    onClick={() =>
                      setDetailVisible(true)
                    }
                    icon={<ButtonIcon className="bi bi-file-earmark-text" />}
                  >
                    Detail
                  </Button>
                }
              />
            </Col>
          )}
        </Row>
        <Row className="mt-8" justify="space-between" gutter={16}>
          <Col span={12}>
            <Card
              className="dashboard-card sub-head1 subtitle2"
              size="small"
              //loading={loading}
              //title={<Title level={5}>Pending Orders</Title>}
              title={renderCardTitle({title: 'Pending Orders', dateRange: rangeDate, fetchData: getOrderPending, setDate: setRangeDate})}
              bodyStyle={{
                //display: 'flex',
                //flexDirection: 'row',
                //justifyContent: 'center',
                //alignItems: 'center',
                height: 140,
              }}
            >
              {/* <Space direction="vertical" style={{ width: '50%' }}> */}
              <Row className="w-100 h-100p" justify="center" gutter={10}>
                <Col span={16}>
                  {loading && <Loading size={32} />}
                  <Card
                    className="statistic-card no-box-shadow fs-16"
                    style={{
                      // borderTopWidth: 3,
                      //    borderTopColor: '#1AFFD5',
                      //backgroundColor: '#1890ff',
                      //borderRadius: 8,
                      display: loading ? 'none' : undefined,
                      height: 115,
                    }}
                  >
                    <Row justify="space-between">
                      <Text className="fs-18 text-statistic-blue">Total</Text>
                      <Link
                        to={`/sales/view-orders?orderStatus=0&warehouseNum=${warehouse.warehouseNum}&enterDate=${rangeDate[0].format(
                          'YYYY-MM-DD'
                        )}@${moment(rangeDate[1])
                          .endOf('day')
                          .format('YYYY-MM-DD HH:mm:ss')}`}
                      >
                        <Text className="fs-20 text-statistic-blue" underline>
                          {orderPending?.total || 0}
                        </Text>
                      </Link>
                    </Row>
                    <Row justify="space-between">
                      <Text>Process Pending</Text>
                      <Link
                        to={`/sales/view-orders?orderStatus=0&warehouseNum=${warehouse.warehouseNum}&advanceProcess=0&enterDate=${rangeDate[0].format(
                          'YYYY-MM-DD'
                        )}@${moment(rangeDate[1])
                          .endOf('day')
                          .format('YYYY-MM-DD HH:mm:ss')}`}
                      >
                        <Text underline>
                          {orderPending?.processpending || 0}
                        </Text>
                      </Link>
                    </Row>
                    <Row justify="space-between">
                      <Text>Queued</Text>
                      <Link
                        to={`/sales/view-orders?orderStatus=0&warehouseNum=${warehouse.warehouseNum}&queueStatus=1&enterDate=${rangeDate[0].format(
                          'YYYY-MM-DD'
                        )}@${moment(rangeDate[1])
                          .endOf('day')
                          .format('YYYY-MM-DD HH:mm:ss')}`}
                      >
                        <Text underline>
                          {orderPending?.queued || 0}
                        </Text>
                      </Link>
                    </Row>
                    <Row justify="space-between">
                      <Text>Non-Queued</Text>
                      <Link
                        to={`/sales/view-orders?orderStatus=0&warehouseNum=${warehouse.warehouseNum}&queueStatus=2&advanceProcess=1&enterDate=${rangeDate[0].format(
                          'YYYY-MM-DD'
                        )}@${moment(rangeDate[1])
                          .endOf('day')
                          .format('YYYY-MM-DD HH:mm:ss')}`}
                      >
                        <Text underline>
                          {orderPending?.nonqueued || 0}
                        </Text>
                      </Link>
                    </Row>
                  </Card>
                </Col>
                {!!orderPending?.requireSmartVerify?.total && (
                  <Col span={6}>
                    <Card
                      className="statistic-card no-box-shadow fs-16"
                      style={{
                        // borderTopWidth: 3,
                        //    borderTopColor: '#FF881A',
                        //borderRadius: 8,
                        //backgroundColor: '#1890ff',
                        display: loading ? 'none' : undefined,
                        height: 115,
                      }}
                    >
                      <Text
                        className="fs-18 text-statistic-blue"
                        ellipsis={{ tooltip: 'Require Smart Verified' }}
                      >
                        Smart Verify
                      </Text>
                      <Row
                        justify="space-between"
                        style={{ paddingLeft: 8, paddingRight: 8 }}
                      >
                        <Text>Total</Text>
                        <Text>
                          {orderPending?.requireSmartVerify?.total || 0}
                        </Text>
                      </Row>
                      <Row
                        justify="space-between"
                        style={{ paddingLeft: 8, paddingRight: 8 }}
                      >
                        <Text>Verified</Text>
                        <Text>
                          {orderPending?.requireSmartVerify?.verified || 0}
                        </Text>
                      </Row>
                    </Card>
                  </Col>
                )}
              </Row>
            </Card>
          </Col>
          <Col span={12}>
            <Card
              className="dashboard-card body-center sub-head1 subtitle3"
              //loading={loading1}
              size="small"
              //title={<Title level={5}>Shipment</Title>}
              title={renderCardTitle({title: 'Shipment', dateRange: rangeDate1, fetchData: getShipmentSpecial, setDate: setRangeDate1})}
              bodyStyle={{
                height: 140,
              }}
            >
              <Row align="middle" className="w-100 h-100p" gutter={16}>
                {loading1 && <Loading size={32} style={{width: '100%'}} />}
                <Col span={shipmentSpecial?.batch?.total ? 6 : 8} style={{ display: loading1 ? 'none' : undefined }}>
                  <Card
                    className="statistic-card no-box-shadow v-center"
                    style={{
                      // borderTopWidth: 3,
                      //    borderTopColor: '#881AFF',
                      //borderRadius: 8,
                      //backgroundColor: '#1890ff',
                      height: 100,
                    }}
                  >
                    <Text
                      className="fs-22 text-statistic-green"
                      ellipsis={{ tooltip: 'Shipped' }}
                    >
                      Shipped
                    </Text>
                    <Text className="fs-30 text-statistic-green">
                      {shipmentSpecial?.shipped?.count || 0}
                    </Text>
                  </Card>
                </Col>
                {!!shipmentSpecial?.batch?.total && (
                  <Col span={6} style={{ display: loading1 ? 'none' : undefined }}>
                    <Card
                      className="statistic-card no-box-shadow text-statistic-blue"
                      style={{
                        // borderTopWidth: 3,
                        //    borderTopColor: '#90FF1A',
                        //borderRadius: 8,
                        //backgroundColor: '#1890ff',
                        display: loading1 ? 'none' : undefined,
                        height: 100,
                      }}
                    >
                      <Row
                        className="w-100"
                        justify="center"
                      >
                        <Text
                          className="fs-22 text-statistic-blue"
                          ellipsis={{ tooltip: 'Batch Print' }}
                        >
                          Batch Print
                        </Text>
                      </Row>
                      <Row
                        className="w-100"
                        justify="space-between"
                      >
                        <Text className="fs-20 text-statistic-blue">Total</Text>
                        <Text className="fs-20 text-statistic-blue">
                          {shipmentSpecial?.batch?.total || 0}
                        </Text>
                      </Row>
                      <Row
                        className="w-100"
                        justify="space-between"
                      >
                        <Text className="fs-20 text-statistic-blue">Verified</Text>
                        <Text className="fs-20 text-statistic-blue">
                          {shipmentSpecial?.batch?.verified || 0}
                        </Text>
                      </Row>
                    </Card>
                  </Col>
                )}
                <Col span={shipmentSpecial?.batch?.total ? 6 : 8} style={{ display: loading1 ? 'none' : undefined }}>
                  <Card
                    className="statistic-card no-box-shadow v-center"
                    style={{
                      // borderTopWidth: 3,
                      //    borderTopColor: '#FF3C1A',
                      //borderRadius: 8,
                      //backgroundColor: '#1890ff',
                      height: 100,
                    }}
                  >
                    <Text
                      ellipsis={{ tooltip: 'Label Printing' }}
                      className="fs-22 text-statistic-kale"
                    >
                      Label Printing
                    </Text>
                    <Text className="fs-30 text-statistic-kale">
                      {shipmentSpecial?.shipping?.count || 0}
                    </Text>
                  </Card>
                </Col>
                <Col span={shipmentSpecial?.batch?.total ? 6 : 8} style={{ display: loading1 ? 'none' : undefined }}>
                  <Card
                    className="statistic-card no-box-shadow v-center"
                    style={{
                      // borderTopWidth: 3,
                      //    borderTopColor: '#FF881A',
                      //borderRadius: 8,
                      //backgroundColor: '#1890ff',
                      height: 100,
                    }}
                  >
                    <Text
                      className="fs-22 text-danger"
                      ellipsis={{ tooltip: 'Cancelled' }}
                    >
                      Cancelled
                    </Text>
                    <Text className="fs-30 text-danger">
                      {shipmentSpecial?.cancelled?.count || 0}
                    </Text>
                  </Card>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row className="mt-16" justify="space-between" gutter={16}>
          <Col span={12}>
            <Card
              className="dashboard-card sub-head1 subtitle4"
              size="small"
              title={renderCardTitle({title: 'Pending Audit Closure', dateRange: rangeDate5, fetchData: getPendingAudit, setDate: setRangeDate5})}
              bodyStyle={{
                //display: 'flex',
                //flexDirection: 'row',
                //justifyContent: 'center',
                //alignItems: 'center',
                height: 120,
              }}
            >
              <Row className="w-100 h-100p" justify="center" gutter={10}>
                <Col span={16}>
                  {loading5 && <Loading size={32} />}
                  <Card
                    className="fs-22 statistic-card no-box-shadow"
                    style={{
                      // borderTopWidth: 3,
                      //    borderTopColor: '#1AFFD5',
                      //backgroundColor: '#1890ff',
                      //borderRadius: 8,
                      display: loading5 ? 'none' : '',
                      height: 90,
                    }}
                  >
                    <Row justify="space-between">
                      <Text className="text-statistic-kale">SKU</Text>
                      <Text className="text-statistic-kale">
                        {pendingAudit.sku || 0}
                      </Text>
                    </Row>
                    <Row justify="space-between">
                      <Text className="text-statistic-blue">Total Line</Text>
                      <Text className="text-statistic-blue">
                        {pendingAudit.lines || 0}
                      </Text>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={12}>
            <Card
              className="dashboard-card sub-head1 subtitle5"
              size="small"
              //title={<Title level={5}>Pending PO Receive Closure</Title>}
              title={renderCardTitle({title: 'Pending PO Receipt Closure', dateRange: rangeDate6, fetchData: getPendingPORecv, setDate: setRangeDate6})}
              bodyStyle={{
                //display: 'flex',
                //flexDirection: 'row',
                //justifyContent: 'center',
                //alignItems: 'center',
                height: 120,
              }}
            >
              <Row className="w-100 h-100p" justify="center" gutter={10}>
                <Col span={16}>
                  {loading6 && <Loading size={32} />}
                  <Card
                    className="fs-20 statistic-card no-box-shadow"
                    style={{
                      // borderTopWidth: 3,
                      //    borderTopColor: '#1AFFD5',
                      //backgroundColor: '#1890ff',
                      //borderRadius: 8,
                      display: loading6 ? 'none' : '',
                      height: 106,
                    }}
                  >
                    <Row justify="space-between">
                      <Text className="text-statistic-kale">Purchase Order</Text>
                      <Text className="text-statistic-kale">
                        {pendingPo.orders || 0}
                      </Text>
                    </Row>
                    <Row justify="space-between">
                      <Text className="text-statistic-yellow">PO Receive Batch</Text>
                      <Text className="text-statistic-yellow">
                        {pendingPo.batch || 0}
                      </Text>
                    </Row>
                    <Row justify="space-between">
                      <Text className="text-statistic-blue">Total Inventory</Text>
                      <Text className="text-statistic-blue">
                        {pendingPo.qty || 0}
                      </Text>
                    </Row>
                  </Card>
                </Col>
              </Row> 
            </Card>
          </Col>
        </Row>
        {props.showShipmentInfo && (<>
        <Collapse
          className="dashboard-card mt-16"
          onChange={() => setShowPendding((prev) => !prev)}
        >
          <Collapse.Panel
            header={<Title level={5}>Pending Shipment</Title>}
            key="1"
            extra={
              <Space>
                {renderDatePicker(rangeDate2, setRangeDate2)}

                <Button
                  size="small"
                  disabled={!showPendding}
                  onClick={(e) => {
                    getShipmentPending();
                    e.stopPropagation()
                  }}
                >
                  <ReloadOutlined
                    spin={false}
                    style={{ fontSize: 12, color: 'green', marginLeft: 4 }}
                  />
                  Refresh
                </Button>
              </Space>
            }
          >
            <Spin spinning={loading2}>
              <Text type="secondary" strong style={{ fontSize: 16 }}>
                Mapped Shipping Service
              </Text>
              <Row gutter={16} style={{ marginBottom: 12 }}>
                <Col span={12}>
                  <Card>
                    {shipmentPending && (
                      <Chart
                        chartType="PieChart"
                        data={[
                          ['Task', 'qty per Total'],
                          ...(shipmentPending?.pending?.shippingservice || [])
                            .sort((a: any, b: any) => b.queued - a.queued)
                            .map((i: any) => [i.name, i.queued]),
                        ]}
                        options={{
                          // legend: 'none',
                          title: `Total Qty:  ${spQueuedQty}`,
                          is3D: true,
                        }}
                        width={'100%'}
                        height={'180px'}
                      />
                    )}
                    <Table
                      style={{ width: '100%' }}
                      scroll={{ y: 180 }}
                      rowKey="name"
                      size="small"
                      columns={QueuedColumns}
                      dataSource={(
                        shipmentPending?.pending?.shippingservice || []
                      )
                        .filter((i: any) => i.queued > 0)
                        .sort((a: any, b: any) => b.queued - a.queued)}
                      pagination={false}
                      bordered
                    />
                  </Card>
                </Col>
                <Col span={12}>
                  <Card>
                    {shipmentPending && (
                      <Chart
                        chartType="PieChart"
                        data={[
                          ['Task', 'qty per Total'],
                          ...(shipmentPending?.pending?.shippingservice || [])
                            .sort((a: any, b: any) => b.unqueued - a.unqueued)
                            .map((i: any) => [i.name, i.unqueued]),
                        ]}
                        options={{
                          // legend: 'none',
                          title: `Total Qty:  ${spQueuedunQty}`,
                          is3D: true,
                        }}
                        width={'100%'}
                        height={'180px'}
                      />
                    )}

                    <Table
                      style={{ width: '100%' }}
                      scroll={{ y: 180 }}
                      rowKey="name"
                      size="small"
                      columns={nonQueuedColumns}
                      dataSource={(
                        shipmentPending?.pending?.shippingservice || []
                      )
                        .filter((i: any) => i.unqueued > 0)
                        .sort((a: any, b: any) => b.unqueued - a.unqueued)}
                      pagination={false}
                      bordered
                    />
                  </Card>
                </Col>
              </Row>
              <Text type="secondary" strong style={{ fontSize: 16 }}>
                Request Shipping Service
              </Text>
              <Row gutter={16}>
                <Col span={12}>
                  <Card>
                    {shipmentPending && (
                      <Chart
                        chartType="PieChart"
                        data={[
                          ['Task', 'qty per Total'],
                          ...(shipmentPending?.pending?.requestservice || [])
                            .sort((a: any, b: any) => b.queued - a.queued)
                            .map((i: any) => [i.name, i.queued]),
                        ]}
                        options={{
                          // legend: 'none',
                          title: `Total Qty:  ${reqQueuedQty}`,
                          is3D: true,
                        }}
                        width={'100%'}
                        height={'180px'}
                      />
                    )}
                    <Table
                      style={{ width: '100%' }}
                      scroll={{ y: 180 }}
                      rowKey="name"
                      size="small"
                      columns={QueuedColumns}
                      dataSource={(
                        shipmentPending?.pending?.requestservice || []
                      )
                        .filter((i: any) => i.queued > 0)
                        .sort((a: any, b: any) => b.queued - a.queued)}
                      pagination={false}
                      bordered
                    />
                  </Card>
                </Col>
                <Col span={12}>
                  <Card>
                    {shipmentPending && (
                      <Chart
                        chartType="PieChart"
                        data={[
                          ['Task', 'qty per Total'],
                          ...(shipmentPending?.pending?.requestservice || [])
                            .sort((a: any, b: any) => b.unqueued - a.unqueued)
                            .map((i: any) => [i.name, i.unqueued]),
                        ]}
                        options={{
                          // legend: 'none',
                          title: `Total Qty:  ${reqQueuedunQty}`,
                          is3D: true,
                        }}
                        width={'100%'}
                        height={'180px'}
                      />
                    )}
                    <Table
                      style={{ width: '100%' }}
                      scroll={{ y: 180 }}
                      rowKey="name"
                      size="small"
                      columns={nonQueuedColumns}
                      dataSource={(
                        shipmentPending?.pending?.requestservice || []
                      )
                        .filter((i: any) => i.unqueued > 0)
                        .sort((a: any, b: any) => b.unqueued - a.unqueued)}
                      pagination={false}
                      bordered
                    />
                  </Card>
                </Col>
              </Row>
            </Spin>
          </Collapse.Panel>
        </Collapse>

        <Collapse
          className="dashboard-card mt-16"
          onChange={() => setShowShipped((prev) => !prev)}
        >
          <Collapse.Panel
            header={<Title level={5}>Shipped Shipment</Title>}
            key="1"
            extra={
              <Space>
                {renderDatePicker(rangeDate3, setRangeDate3)}

                <Button
                  size="small"
                  disabled={!showShipped}
                  onClick={(e) => {
                    getShipmentShipped();
                    e.stopPropagation();
                  }}
                >
                  <ReloadOutlined
                    spin={false}
                    style={{ fontSize: 12, color: 'green', marginLeft: 4 }}
                  />
                  Refresh
                </Button>
              </Space>
            }
          >
            <Spin spinning={loading3}>
              <Row
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  flexDirection: 'row',
                }}
              >
                <div style={{ width: '50%' }}>
                  {shipmentPending && (
                    <Chart
                      chartType="PieChart"
                      data={[
                        ['Task', 'qty per Total'],
                        ...(shipmentShipped?.shipped?.carriers || [])
                          .sort((a: any, b: any) => b.value - a.value)
                          .map((i: any) => [i.name, i.value]),
                      ]}
                      options={{
                        title: `Total Shipped Shipments : ${shipmentShipped?.shipped?.count || 0
                          }`,
                        is3D: true,
                      }}
                      width={'100%'}
                      height={'180px'}
                    />
                  )}
                </div>
                <Table
                  style={{ width: '50%' }}
                  scroll={{ y: 180 }}
                  rowKey="name"
                  size="small"
                  columns={shippedColumns}
                  dataSource={(shipmentShipped?.shipped?.carriers || []).sort(
                    (a: any, b: any) => b.value - a.value
                  )}
                  pagination={false}
                  bordered
                />
              </Row>
            </Spin>
          </Collapse.Panel>
        </Collapse>
        </>)}

        {showOrderInfo && (
          <Card
            loading={loading4}
            size="small"
            style={{ marginTop: 12, paddingRight: 24 }}
            title={<Title level={5}>Orders Info </Title>}
            // bodyStyle={{
            //   height: 200,
            // }}
            extra={
              <Space>
                {renderDatePicker(rangeDate4, setRangeDate4)}

                <Button
                  size="small"
                  onClick={() => {
                    getOrderStatusInfo();
                  }}
                >
                  <ReloadOutlined
                    spin={false}
                    style={{ fontSize: 12, color: 'green', marginLeft: 4 }}
                  />
                  Refresh
                </Button>
              </Space>
            }
          >
            <Row
              style={{
                display: 'flex',
                justifyContent: 'start',
                flexDirection: 'row',
              }}
            >
              <div style={{ width: '50%' }}>
                <Chart
                  chartType="PieChart"
                  data={[
                    ['Task', 'qty per Total'],
                    ...(orderStatusInfo?.advanceProcess || [])
                      .sort((a: any, b: any) => b.value - a.value)
                      .map((i: any) => [i.name, i.value]),
                  ]}
                  options={{
                    title: `Total Orders : ${orderInfoTotal}`,
                    is3D: true,
                  }}
                  width={'100%'}
                  height={'180px'}
                />
              </div>
              <Table
                style={{ width: '50%' }}
                scroll={{ y: 180 }}
                size="small"
                rowKey="name"
                columns={statusColumns}
                dataSource={(orderStatusInfo?.advanceProcess || []).sort(
                  (a: any, b: any) => b.value - a.value
                )}
                pagination={false}
                bordered
              />
            </Row>
          </Card>
        )}
        {hasManagerReportPermission() && (<>
        {/*<Row className="ant-card dashboard-card head1 subtitle3 mt-16 pb-8">
          <Row className="ant-card-head w-100" justify="center">
            <Label className="color-f-1 fs-16 label-bold">Manager Report</Label>
          </Row>*/}
          <Row className="w-100">
            <Col className="p-16-8-16-0" span={12}> 
              <div className="ant-card dashboard-card head2 subtitle2 h-100p">
                <Row align="middle" className="card-head p-8-10 w-100">
                  {/*<Label className="text-color-f-1 fs-16 label-bold">Inventory Change Report</Label>*/}
                  {renderCardTitle({title: 'Inventory Change Summary', dateRange: rangeDate7, fetchData: getInventoryChange, setDate: setRangeDate7})}
                </Row>
                <Row align="middle" className="" style={{height: 'calc(100% - 42px)'}}>
                  {loading7 && <Loading size={32} style={{width: '100%'}} />}
                  <Col className="p-0-14-0-28" span={12} style={{ display: loading7 ? 'none' : '' }}>
                    <Card
                      className="fs-16 statistic-card"
                      style={{
                        //backgroundColor: '#1890ff',
                        //borderRadius: 8,
                        height: 100,
                      }}
                    >
                      <Row justify="space-between">
                        <Text className="fs-20 text-statistic-kale">Adjustment</Text>
                      </Row>
                      <Row justify="space-between">
                        <Text>SKU Count</Text>
                        <Text>
                          {inventoryChange.adjust ? inventoryChange.adjust.count : 0}
                        </Text>
                      </Row>
                      <Row justify="space-between">
                        <Text>Total Quantity</Text>
                        <Text>
                          {inventoryChange.adjust ? inventoryChange.adjust.qty : 0}
                        </Text>
                      </Row>
                    </Card>
                  </Col>
                  <Col className="p-0-28-0-14" span={12} style={{ display: loading7 ? 'none' : '' }}>
                    <Card
                      className="fs-16 statistic-card"
                      style={{
                        //backgroundColor: '#1890ff',
                        //borderRadius: 8,
                        height: 100,
                      }}
                    >
                      <Row justify="space-between">
                        <Text className="fs-20 text-statistic-blue">PO Receive</Text>
                      </Row>
                      <Row justify="space-between">
                        <Text>SKU Count</Text>
                        <Text>
                          {inventoryChange.poreceive ? inventoryChange.poreceive.count : 0}
                        </Text>
                      </Row>
                      <Row justify="space-between">
                        <Text>Total Quantity</Text>
                        <Text>
                          {inventoryChange.poreceive ? inventoryChange.poreceive.qty : 0}
                        </Text>
                      </Row>
                    </Card>
                  </Col>
                  <Col className="p-0-14-0-28" span={12} style={{ display: loading7 ? 'none' : '' }}>
                    <Card
                      className="fs-16 statistic-card"
                      style={{
                        height: 100,
                      }}
                    >
                      <Row justify="space-between">
                        <Text className="fs-20 text-statistic-purple">Cycle Count</Text>
                      </Row>
                      <Row justify="space-between">
                        <Text>SKU Count</Text>
                        <Text>
                          {inventoryChange.clyclecount ? inventoryChange.cyclecount.count : 0}
                        </Text>
                      </Row>
                      <Row justify="space-between">
                        <Text>Total Quantity</Text>
                        <Text>
                          {inventoryChange.clyclecount ? inventoryChange.cyclecount.qty : 0}
                        </Text>
                      </Row>
                    </Card>
                  </Col>
                  <Col className="p-0-28-0-14" span={12} style={{ display: loading7 ? 'none' : '' }}>
                    <Card
                      className="fs-16 statistic-card"
                      style={{
                        height: 100,
                      }}
                    >
                      <Row justify="space-between">
                        <Text className="fs-20 text-statistic-yellow">Return</Text>
                      </Row>
                      <Row justify="space-between">
                        <Text>SKU Count</Text>
                        <Text>
                          {inventoryChange.return ? inventoryChange.return.count : 0}
                        </Text>
                      </Row>
                      <Row justify="space-between">
                        <Text>Total Quantity</Text>
                        <Text>
                          {inventoryChange.return ? inventoryChange.return.qty : 0}
                        </Text>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col> 
            <Col className="p-16-0-16-8" span={12}> 
              <div className="ant-card dashboard-card head2 subtitle4">
                <Row className="card-head p-8-12 w-100" justify="space-between">
                  <Label className="color-f-1 fs-16 label-bold">Location Summary</Label>
                </Row>
                <Row className="pb-8 pt-8" justify="center">
                  <Col className="p-4" span={18}>
                    {loading8 && <Loading size={32} />}
                    <Card
                      className="fs-16 statistic-card"
                      style={{
                        display: loading8 ? 'none' : '',
                        height: 60,
                      }}
                    >
                      <Row justify="space-between">
                        <Text className="text-statistic-kale">SKU Count</Text>
                        <Text className="text-statistic-kale">
                          {location.sku ? location.sku.count : 0}
                        </Text>
                      </Row>
                      <Row justify="space-between">
                        <Text className="text-statistic-blue">Total Quantity</Text>
                        <Text className="text-statistic-blue">
                          {location.sku ? location.sku.qty : 0}
                        </Text>
                      </Row>
                    </Card>
                  </Col>
                  <Col className="p-4" span={18}>
                    <Card
                      className="fs-14 statistic-card"
                      style={{
                        //backgroundColor: '#1890ff',
                        //borderRadius: 8,
                        display: loading8 ? 'none' : '',
                        //height: 170,
                      }}
                    >
                      <Row justify="center">
                        <Text className="fs-18 text-statistic-kale">Location Count by Quantity</Text>
                      </Row>
                      <Row justify="space-between">
                        <Text className="text-color-f-2">Qty 0</Text>
                        <Text className="text-color-f-2">
                          {location.items ? location.items['Qty 0'] : 0}
                        </Text>
                      </Row>
                      <Row justify="space-between">
                        <Text className="text-color-f-2">Qty 1 to 5</Text>
                        <Text className="text-color-f-2">
                          {location.items ? location.items['Qty 1 to 5'] : 0}
                        </Text>
                      </Row>
                      <Row justify="space-between">
                        <Text className="text-color-f-2">Qty 6 to 10</Text>
                        <Text className="text-color-f-2">
                          {location.items ? location.items['Qty 6 to 10'] : 0}
                        </Text>
                      </Row>
                      <Row justify="space-between">
                        <Text className="text-color-f-2">Qty 11 to 20</Text>
                        <Text className="text-color-f-2">
                          {location.items ? location.items['Qty 11 to 20'] : 0}
                        </Text>
                      </Row>
                      <Row justify="space-between">
                        <Text className="text-color-f-2">Qty 21 and above</Text>
                        <Text className="text-color-f-2">
                          {location.items ? location.items['Qty 21 and above'] : 0}
                        </Text>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col> 
          </Row>
          <Row className="w-100">
            <Col className="p-4-0-4-0" span={24}> 
              <div className="ant-card dashboard-card head2 subtitle5">
                <Row className="card-head p-8-16 w-100">
                  {renderCardTitle({title: 'Shipment Handling Summary', dateRange: rangeDate9, fetchData: getEmployeeShipment, setDate: setRangeDate9})}
                  {/*<Space size="small">
                    {renderDatePicker(rangeDate9, (rd: any) => {setRangeDate9(rd);getEmployeeShipment(rd);})}
                    <Button
                      disabled={loading9}
                      onClick={() => getEmployeeShipment()}
                      size="small"
                    >
                      <ReloadOutlined
                        style={{ fontSize: 12, color: 'green', marginLeft: 4 }}
                      />
                      {width >= 1280 ? 'Refresh' : ''}
                    </Button>
                  </Space>*/}
                </Row>
                <Row className="" style={{ width: '100%' }}>
                    <Table
                      bordered
                      columns={employeeShipmentColumns}
                      dataSource={employeeShipmentData}
                      loading={loading9 ? { indicator: <Loading size={32} /> } : false}
                      pagination={false}
                      rowKey="employee"
                      scroll={{ y: 180 }}
                      size="small"
                      style={{ width: '100%' }}
                    />
                </Row>
              </div>
            </Col> 
          </Row>
        {/*</Row>*/}
        </>)}
      </Card>
      {
        detailVisible && <ErrorDetail
        visible
        onHide={()=> setDetailVisible(false)}
        warehouseNum={warehouse.id}
        params={{
          start: convertToUtcTime(rangeDate1[0].startOf('day').format()),
          end: convertToUtcTime(rangeDate1[1].endOf('day').format()),
        }}
        />
      }
    </>
  );
}
